<template>
  <div>
    <div>
      <input-debounced
        v-model="search"
        v-bind="input"
        class="w-100"
      ></input-debounced>
    </div>
    <BaseList
      ref="list"
      :url="url"
      v-bind="list"
      class="overflow-auto"
    >
      <template #default="slotProps">
        <slot v-bind="slotProps"></slot>
      </template>
    </BaseList>
  </div>
</template>

<script>
import BaseList from "../../list.vue";
import { addQueryParams } from "../../../libs/url";
import { isFilled } from "../../../helpers";

export default {
  components: {
    BaseList,
  },

  props: {
    baseUrl: String,
    input: Object,
    list: Object,
  },

  data() {
    return {
      filters: {},
    };
  },

  computed: {
    /**
     * @return {string}
     */
    url() {
      return addQueryParams(this.baseUrl, this.filters);
    },

    search: {
      get: function () {
        return _.get(this.filters, 'search', null);
      },
      set: function (search) {
        this.filters = _.assign({}, _.omit(this.filters, 'search'), isFilled(search) ? {search} : {});
      },
    },
  },

  methods: {
    /**
     * @return {undefined}
     */
    refresh() {
      this.$refs.list.refresh();
    },
  }
}
</script>
